/***
 *
 *   PROFILE
 *   Update the user profile or close the account.
 *
 **********/

import { useContext, useEffect } from "react";
import {
  AuthContext,
  ViewContext,
  Form,
  Card,
  Row,
  Button,
  useNavigate,
  Animate,
  Event,
  useAPI,
} from "components/lib";

export function Profile({ t }) {
  const navigate = useNavigate();

  // context
  const authContext = useContext(AuthContext);
  const viewContext = useContext(ViewContext);

  // fetch
  const user = useAPI("/api/user");

  // Prevent horizontal scroll on mount
  useEffect(() => {
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflowX = 'hidden';
    return () => {
      document.body.style.overflowX = 'auto';
      document.documentElement.style.overflowX = 'auto';
    };
  }, []);

  function closeAccount() {
    viewContext.dialog.open(
      {
        title: t ? t("account.profile.form.close_account.title") : "Delete Your Account",
        description: t ? t("account.profile.form.close_account.description") : "This action cannot be undone. This will permanently delete your account and all associated data.",
        form: {
          inputs: false,
          method: "DELETE",
          destructive: true,
          url: authContext.permission.owner ? "/api/account" : "/api/user",
          buttonText: t ? t("account.profile.form.close_account.button") : "Delete Account",
        },
      },
      () => {
        // destory user
        Event({ name: "closed_account" });
        localStorage.clear();
        navigate("/signup");
      }
    );
  }

  return (
    <Animate>
      <Row width="lg">
        <Card title={t ? t("account.profile.subtitle") : "Edit Your Profile"} loading={user.loading}>
          <Form
              buttonText={t ? t("account.profile.form.button") : "Save"}
              url="/api/user"
              method="PATCH"
              inputs={{
                name: {
                  label: t ? t("account.profile.form.name.label") : "Your Name *",
                  type: "text",
                  required: true,
                  value: user?.data?.name || "Brent",
                  errorMessage: t ? t("account.profile.form.name.error") : "Please enter your name",
                },
                email: {
                  label: t ? t("account.profile.form.email.label") : "Email address *",
                  type: "email",
                  required: true,
                  value: user?.data?.email || "brent.vanderheiden@mapmetrics.org",
                  errorMessage: t ? t("account.profile.form.email.error") : "Please enter a valid email address",
                },
                avatar: {
                  label: t ? t("account.profile.form.avatar.label") : "Profile Picture",
                  type: "file",
                  accept: ["image/png", "image/jpeg", "image/jpg"],
                  required: false,
                  max: 1,
                },
                account_name: {
                  type: "text",
                  label: t ? t("account.profile.form.account_name.label") : "Account Name",
                  value: user?.data?.account_name || "My Account",
                },
              }}
              callback={(res) => {
                const data = res.data.data;

                // update the account name
                if (
                  data.account_name &&
                  authContext.user?.accounts?.length > 0
                ) {
                  const accounts = [...authContext.user.accounts];
                  accounts[
                    accounts.findIndex(
                      (x) => x.id === authContext.user.account_id
                    )
                  ].name = data.account_name;
                  authContext.update({ accounts: accounts });
                }

                // update the user name
                if (data.name) authContext.update({ name: data.name });

                // update the avatar
                if (data.avatar) authContext.update({ avatar: data.avatar });

                // user changed email and needs to verify
                if (data.hasOwnProperty("verified") && !data.verified) {
                  authContext.update({ verified: false });
                  navigate("/signup/verify");
                }
              }}
            />
        </Card>
      </Row>

      <Row width="lg">
        <Card title="Danger Zone">
          <Button
            variant="destructive"
            action={closeAccount}
            text={t ? t("account.profile.form.close_account.title") : "Delete Your Account"}
          />
        </Card>
      </Row>
    </Animate>
  );
}